import { setRemoteDefinitions } from '@nrwl/angular/mf';

import('@aon-rdc/env').then(module => {
  setRemoteDefinitions(module.environment.remotes);
  import('./bootstrap')
    .catch((err) => console.error("Error encountered while bootstrapping [shell]: ", err))
}).catch((err) => console.error("Error loading environment [shell/main.ts]: ", err))
